import React from 'react';
import InfiniteLogoSlider from 'react-infinite-logo-slider';
import './OurClients.css';
import { clientLogos } from '../../assets/client_logos';

const OurClients: React.FC = () => {

  return (
    <section className="our-clients">
      <div className="container">
        <div className="our-clients__header">
          <h2 className="our-clients__title">Our Clients</h2>
          <p className="our-clients__subtitle">
            Trusted by leading organizations across various industries
          </p>
        </div>
        
        <div className="our-clients__slider">
          <InfiniteLogoSlider
            width="150px"
            duration={30}
            pauseOnHover={true}
            blurBorders={false}
            blurBorderColor={'#fff'}
          >
            {clientLogos.map((logo, index) => (
              <InfiniteLogoSlider.Slide key={index}>
                <img 
                  src={logo.src} 
                  alt={logo.alt}
                  className="client-logo"
                />
              </InfiniteLogoSlider.Slide>
            ))}
          </InfiniteLogoSlider>
        </div>
      </div>
    </section>
  );
};

export default OurClients;
